export class NotificationsConstants {
  public static API: any = {
    markAsRead: '/fcm/v1/mark_read',
    markAsUnRead: '/fcm/v1/un_read'
  };
}
